import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
/**
 * Generated class for the FormatPricePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatWindDirection',
})
export class FormatWindDirectionPipe implements PipeTransform {
  /**
   * Takes a job and displays the compensation in a human readable format Based
   * on the following fields:

   */

  formatTemp = function(value) {
    const val = _.toInteger(value / 22.5 + 0.5);
    const arr = [
      'N',
      'NNE',
      'NE',
      'ENE',
      'E',
      'ESE',
      'SE',
      'SSE',
      'S',
      'SSW',
      'SW',
      'WSW',
      'W',
      'WNW',
      'NW',
      'NNW',
    ];
    return arr[val % 16];
  };

  transform(value: any, ...args) {
    return this.formatTemp(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-wind-direction/format-wind-direction.ts